import { DPPrefixTypes, MarketPrefixTypes, Proposition } from './constants';

const getUrlPathPrefix = (): string => {
  const urlPath = window.location.pathname;
  const path = urlPath.split('/');
  return path.length > 1 ? path[1] : '';
};

export const currentProposition = (): string | undefined => {
  const pathPrefix = getUrlPathPrefix();
  let proposition: string | undefined = undefined;

  if (MarketPrefixTypes.includes(pathPrefix)) {
    proposition = Proposition.Market;
  } else if (DPPrefixTypes.includes(pathPrefix)) {
    proposition = Proposition.DistributionPanel;
  }

  if (proposition === undefined) {
    console.error(`Unknown proposition for path prefix: ${pathPrefix}`);
  }

  return proposition;
};
